import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import EdiItemCodeMappingMaintenanceCont from "presentation/view/container/EdiItemCodeMapping/EdiItemCodeMappingContMain";

CommonEntrypoint(<EdiItemCodeMappingMaintenanceCont/>)